import { PasswordFormSessionComponent } from './passwordFormSession.component';
import { ComponentRef, ViewContainerRef } from '@angular/core';
import { SetPasswordFormComponent } from '../set-password-form/set-password-form.component';
import { ConfirmPasswordComponent } from '../change-password/confirm-password/confirm-password.component';
export class PasswordAuthenticatorSession {
  clientContext: any;
  viewContainerRef: ViewContainerRef;
  passwordFormSessionCompRef: ComponentRef<PasswordFormSessionComponent>;
  setPasswordFormSessionCompRef: ComponentRef<SetPasswordFormComponent>;
  confirmPasswordChangeComponent: ComponentRef<ConfirmPasswordComponent>;

  actionContext: any;
  submitHandler: any;
  mode: any;
  title: string;
  username: string;
  description: any;
  actionEscapeOption: any;


  constructor(title, username){
      this.title = title;
      this.username = username;
  }
  // this.submitHandler = null;

  startSession(
    description: com.ts.mobile.sdk.AuthenticatorDescription,
    mode: com.ts.mobile.sdk.AuthenticatorSessionMode,
    actionContext: com.ts.mobile.sdk.PolicyAction | null,
    clientContext: object | null
  ): void {
    this.actionContext = actionContext;
    this.clientContext = clientContext;
    this.mode = mode;

    // Get Authenticator description
    this.description = description;
    this.actionEscapeOption = false;
  }

  endSession(): void {
    const userId = this.clientContext['cookieService'].get('username');
    const flow = this.clientContext['nextStep'];
    if (this.passwordFormSessionCompRef && flow !== 'forgotPasswordFlow'){
      this.passwordFormSessionCompRef.instance.onSessionEstablished(userId);
    }
    this.clientContext['cookieService'].delete('errorPwdCode');
  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<ResponseType>>{
    this.viewContainerRef = (this.clientContext as any).viewContainerRef;
    this.viewContainerRef.clear();
    const userId = this.clientContext['userID'];

    // To check if a credential recovery escape has been configured for the specific authentication method,
    // the UI Layer implementation should consult AuthenticatorDescription.getCredentialRecoveryEscapeOption:
    if (this.description.getCredentialRecoveryEscapeOption()) {
        this.actionEscapeOption = true;
     }

    if (this.mode === com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication) {
      this.passwordFormSessionCompRef = this.viewContainerRef.createComponent(PasswordFormSessionComponent);
      this.passwordFormSessionCompRef.instance.onSubmitCode = this.onSubmitCode;
      this.passwordFormSessionCompRef.instance.username = userId;
      this.passwordFormSessionCompRef.instance.passkeyCancelError = this.clientContext['WebAuthNerror'];
      this.passwordFormSessionCompRef.instance.passkeyAuthError = this.clientContext['webAuthNDialogResponse'];

      this.passwordFormSessionCompRef.instance.onForgotPassword = this.onForgotPasswordClick.bind(this);
      this.passwordFormSessionCompRef.instance.onChangeUsernameClick = this.onChangeUsername.bind(this);
      this.passwordFormSessionCompRef.instance.returnToClientApplicationWithError = this.returnToClientApplicationWithError.bind(this);
    }

    else if (this.mode === com.ts.mobile.sdk.AuthenticatorSessionMode.Registration){
      this.setPasswordFormSessionCompRef = this.viewContainerRef.createComponent(SetPasswordFormComponent);
      this.setPasswordFormSessionCompRef.instance.username = userId;

      this.setPasswordFormSessionCompRef.instance.onResetPasswordSubmit = this.onResetPasswordSubmit;
      this.setPasswordFormSessionCompRef.instance.onRemindPasswordSubmit = this.onSkipPasswordExpiry;
      this.setPasswordFormSessionCompRef.instance.setSelf = this;
    }
    else{
    }

    return new Promise((resolve, reject) => {
      this.submitHandler = (response) => {
        resolve(response);
        this.submitHandler = null;
      };
    });
  }

  promiseRecoveryForError(
    error: com.ts.mobile.sdk.AuthenticationError,
    validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>,
    defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery
  ): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    return new Promise((resolve, reject) => {
      const userId = this.clientContext['cookieService'].get('userEmail');

      if (this.mode ===  com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication){
      const newLocal = 'additional_data';
      const errorCode = error.getData()[newLocal].code;
      if (errorCode === 'UE03'){ // incorrect password
        setTimeout(() => this.passwordFormSessionCompRef.instance.setErrorCode(errorCode), 100);
        resolve(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator);
      }
      else if (errorCode === 'UE04'){ // user locked after password tries done
        // setTimeout(() => this.passwordFormSessionCompRef.instance.setErrorCode(errorCode));

        // resolve(defaultRecovery);
        // resolve(com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail);

        // To return to client app with error
        this.returnToClientApplicationWithError(errorCode, 'Account Locked');
      }
      else {
        // technical error SE01. Show on SPA.
        setTimeout(() => this.passwordFormSessionCompRef.instance.setErrorCode('SE01'), 100);
        resolve(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator);
        resolve(defaultRecovery);
      }
    }
    else if (this.mode ===  com.ts.mobile.sdk.AuthenticatorSessionMode.Registration){

    }

    });
  }


  returnToClientApplicationWithError(error, errorDescription) {
    const url = this.clientContext['cookieService'].get('redirect_uri');

    let state = this.clientContext['cookieService'].get('state');
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + error
       + '&error_description=' +  errorDescription
       + '&lang=' + this.clientContext['cookieService'].get('lang')
       + '&state=' + state;
    return;

  }


  changeSessionModeToRegistrationAfterExpiration() {
  }

  /** Non UIFormSession interface Functions */
  onSubmitCode = (code: string) => {
    const inputResponse = com.ts.mobile.sdk.PasswordInput.create(code);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);
    this.clientContext['cookieService'].set('errorPwdCode', code, undefined, undefined, null, true, 'None');
    this.submitHandler(response);
  }

  onResetPasswordSubmit = (password: string) => {
    const inputResponse = com.ts.mobile.sdk.PasswordInput.create(password);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);
    this.submitHandler(response);
  }

  onSkipPasswordExpiry(currentSelf: any) {
    //      const this = this;
    // // If the user chooses this option, the UI implementation should trigger
    // // the escape by creating an escape request with the provided option and returning it
    // // from UIAuthenticatorSession.promiseInput
    // const escapeOption =
    //         actionContext.escapeOptionById(
    //           description.getCredentialRecoveryEscapeOption().getId());

    // if (!escapeOption) {
    //     console.error(`unable to find a "Forgot Password" option in actionContext.escapeOptions`);
    // }
    // else
    // {
    //   this.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(escapeOption, new Object()));
    //   this.clientContext['nextStep'] = 'forgotPasswordFlow';
    // }

        const escapeOptions = currentSelf.actionContext.getEscapeOptions();

        if (escapeOptions && escapeOptions.length > 0) {
            // Use the first available escape option
            const escapeOption = escapeOptions[0];
            const escapeOptionId = escapeOption.getId();
            //this.submitHandler(escapeOption);
            currentSelf.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(escapeOption, new Object()));
        } else {
            console.error("No escape options available in actionContext");
        }
  }

  private onForgotPasswordClick(){
    // If the user chooses this option, the UI implementation should trigger
    // the escape by creating an escape request with the provided option and returning it
    // from UIAuthenticatorSession.promiseInput
    const forgotPasswordEscapeOption =
            this.actionContext.escapeOptionById(
              this.description.getCredentialRecoveryEscapeOption().getId());

    if (!forgotPasswordEscapeOption) {
        console.error(`unable to find a "Forgot Password" option in actionContext.escapeOptions`);
    }
    else
    {
      this.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(forgotPasswordEscapeOption, new Object()));
      this.clientContext['nextStep'] = 'forgotPasswordFlow';
    }
  }

  private onChangeUsername(){
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'change_username';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=username'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }
}
export default PasswordAuthenticatorSession;
